<style lang="less">
    @import './styles/login.less';
</style>

<template>
  <div class="login" @keydown.enter="handleSubmit" v-show="false">
    <div class="login-con">

      <div class="ff-card">
        <div class="form-con">
          <a-form
            id="formLogin"
            class="user-layout-login"
            ref="formLogin"
            :form="form"
            @submit="handleSubmit"
          >
            <a-form-item>
              <div class="card-title">欢迎登陆</div>
            </a-form-item>
            <a-icon type="user" class="ff-icon" /><span>用户名/USER NAME</span>
            <a-form-item style="margin-bottom: 8px">
              <a-input
                type="text"
                placeholder="帐户名"
                v-decorator="[
                  'username',
                  {rules: [{ required: true, message: '请输入用户名' }, { validator: handleUsernameOrEmail }], validateTrigger: 'change'}
                ]"
              >
              </a-input>
            </a-form-item>

            <a-icon type="lock" class="ff-icon" /><span>密码/PASSWORD</span>
            <a-form-item style="margin-bottom: 8px">
              <a-input
                type="password"
                autocomplete="false"
                placeholder="密码"
                v-decorator="[
                  'password',
                  {rules: [{ required: true, message: '请输入密码' }], validateTrigger: 'blur'}
                ]"
              >
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-checkbox
                :checked="isRemember"
                @change="handleChange"
              >记住密码</a-checkbox>
              <!-- <router-link
                :to="{ name: 'recover', params: { user: 'aaa'} }"
                class="forge-password"
                style="float: right;"
              >忘记密码</router-link> -->
            </a-form-item>
            <a-row type="flex" justify="center">
              <a-col :span="4">
                <a-form-item style="margin-bottom: 0;">
                  <a-button
                    size="large"
                    block
                    type="primary"
                    htmlType="submit"
                    class="login-button"
                    :loading="state.loginBtn"
                    :disabled="state.loginBtn"
                    icon="arrow-right"
                    shape="circle"
                    style="width:56px;height:56px;"
                  />
                </a-form-item>
              </a-col>

            </a-row>

          </a-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { timeFix } from '@/utils/util'
import Vue from 'vue'
import { ACCESS_TOKEN } from '../../store/mutation-types'

export default {
  data () {
    return {
      customActiveKey: 'tab1',
      loginBtn: false,
      // login type: 0 email, 1 username, 2 telephone
      loginType: 0,
      requiredTwoStepCaptcha: false,
      stepCaptchaVisible: false,
      form: this.$form.createForm(this),
      state: {
        time: 60,
        loginBtn: false,
        // login type: 0 email, 1 username, 2 telephone
        loginType: 0,
        smsSendBtn: false
      },
      isRemember: false
    }
  },
  created () {
    console.log('this.$route.params', this.$route.params)
    console.log('this.$route.query', this.$route.query)
    const query = this.$route.query
    console.log('routeQuery', query)
    // 如果连接里带着token 直接跳转
    if (query && query.ticket || this.$sysInfo.ifDebug) {
      // this.loginSuccess()
      this.Login({ code: query.ticket })
        .then((res) => {
          this.loginSuccess()
          console.log('suc', res)
        })
        .catch(err => {
          console.log('err', err)
        })
    }

  //   get2step({ })
  //     .then(res => {
  //       this.requiredTwoStepCaptcha = res.result.stepCode
  //     })
  //     .catch(() => {
  //       this.requiredTwoStepCaptcha = false
  //     })
  //   // this.requiredTwoStepCaptcha = true
  },
  // mounted () {
  //   this.getLocalStorage()

  //   // 测试用code获取
  //   // this.initAuthorizeCode()
  // },
  methods: {
    ...mapActions(['Login', 'Logout']),

    // // 测试用AuthorizeCode获取
    // initAuthorizeCode () {
    //   getOAAuthorize().then(res => {
    //     console.log('getOAAuthorize', res)
    //   })
    // },

    // handler
    handleUsernameOrEmail (rule, value, callback) {
      const { state } = this
      const regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/
      if (regex.test(value)) {
        state.loginType = 0
      } else {
        state.loginType = 1
      }
      callback()
    },
    // 记住密码勾选框变化回调
    handleChange (e) {
      this.isRemember = e.target.checked
    },
    handleSubmit (e) {
      e.preventDefault()
      const {
        form: { validateFields },
        state,
        customActiveKey,
        Login
      } = this

      state.loginBtn = true

      const validateFieldsKey = customActiveKey === 'tab1' ? ['username', 'password'] : ['mobile', 'captcha']

      validateFields(validateFieldsKey, { force: true }, (err, values) => {
        if (!err) {
          console.log('login form', values)
          if (this.isRemember) {
            window.localStorage.setItem('username', values.username)
            window.localStorage.setItem('password', values.password)
            window.localStorage.setItem('remember', this.isRemember)
          } else {
            this.clearUserInfo()
          }
          const loginParams = { ...values }
          delete loginParams.username
          loginParams[!state.loginType ? 'email' : 'username'] = values.username
          loginParams.password = values.password
          // loginParams.password = md5(values.password)
          Login(loginParams)
            .then((res) => {
              this.loginSuccess(res)
            })
            .catch(err => {
              console.log(err)
              // this.requestFailed(err)
            })
            .finally(() => {
              state.loginBtn = false
            })
        } else {
          setTimeout(() => {
            state.loginBtn = false
          }, 600)
        }
      })
    },
    // getCaptcha (e) {
    //   e.preventDefault()
    //   const { form: { validateFields }, state } = this

    //   validateFields(['mobile'], { force: true }, (err, values) => {
    //     if (!err) {
    //       state.smsSendBtn = true

    //       const interval = window.setInterval(() => {
    //         if (state.time-- <= 0) {
    //           state.time = 60
    //           state.smsSendBtn = false
    //           window.clearInterval(interval)
    //         }
    //       }, 1000)

    //       const hide = this.$message.loading('验证码发送中..', 0)
    //       getSmsCaptcha({ mobile: values.mobile }).then(res => {
    //         setTimeout(hide, 2500)
    //         this.$notification['success']({
    //           message: '提示',
    //           description: '验证码获取成功，您的验证码为：' + res.result.captcha,
    //           duration: 8
    //         })
    //       }).catch(err => {
    //         setTimeout(hide, 1)
    //         clearInterval(interval)
    //         state.time = 60
    //         state.smsSendBtn = false
    //         this.requestFailed(err)
    //       })
    //     }
    //   })
    // },
    // stepCaptchaSuccess () {
    //   this.loginSuccess()
    // },
    // stepCaptchaCancel () {
    //   this.Logout().then(() => {
    //     this.loginBtn = false
    //     this.stepCaptchaVisible = false
    //   })
    // },
    loginSuccess () {
      this.$router.push({ path: '/homePage' })
      setTimeout(() => {
        this.$notification.success({
          message: '欢迎',
          description: `${timeFix()}，欢迎回来`
        })
      }, 1000)
    },
    requestFailed (err) {
      this.$notification['error']({
        message: '错误',
        description: ((err.response || {}).data || {}).message || '请求出现错误，请稍后再试',
        duration: 4
      })
    },
    clearUserInfo () {
      window.localStorage.setItem('username', '')
      window.localStorage.setItem('password', '')
      window.localStorage.setItem('remember', false)
    },
    getLocalStorage () {
      const username = window.localStorage.getItem('username')
      const password = window.localStorage.getItem('password')
      const remember = window.localStorage.getItem('remember')
      console.log(username, password, remember)
      if (remember === 'true') {
        this.$nextTick(() => {
          this.form.setFieldsValue({
            username: username,
            password: password
          })
        })
        this.isRemember = true
      }
    }
  }
}
</script>

<style scoped>
.ant-form-item{
  margin-bottom: 24px;
}
.ff-card{
  border-radius: 5px;
  padding: 24px 32px;
  background: rgba(255, 255, 255,0.19);
}
</style>
